// extracted by mini-css-extract-plugin
export default {"container":"kIhE2RlI3UHmXcbM5MVH","background":"FjeuhlJ2dEiHxCmn_X2j","stroke":"fYKwZVZmeQbyucqEnO8F","fill":"TZVR5U2JK2z58pZDAKKA"};